import {FormattedMessage} from 'react-intl';
import {Checkmark} from '../../components';

export function PersonalDataContent() {
    return (
        <ul className={'no-decoration'}>
            <li className={'with-checkmark is-heavy'}>
                <Checkmark />
                <FormattedMessage id={'trust-and-privacy.personal-data.one'} />
            </li>
            <li className={'with-checkmark is-heavy'}>
                <Checkmark />
                <FormattedMessage id={'trust-and-privacy.personal-data.two'} />
            </li>
            <li className={'with-checkmark is-heavy'}>
                <Checkmark />
                <FormattedMessage id={'trust-and-privacy.personal-data.three'} />
            </li>
        </ul>
    );
}
